import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ThemePreferenceQueryVariables = Types.Exact<{
  flag: Types.Scalars['String']['input'];
}>;


export type ThemePreferenceQuery = { __typename?: 'RootQueryType', featureFlag?: { __typename?: 'FeatureFlag', name: string, enabled: boolean } | null, currentUser?: { __typename?: 'User', id: string, colorModePreference: string } | null };

export type UpdateColorModePreferenceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  colorModePreference: Types.Scalars['String']['input'];
}>;


export type UpdateColorModePreferenceMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'UpdateUserResult', result?: { __typename?: 'User', id: string, colorModePreference: string } | null } };


export const ThemePreferenceDocument = gql`
    query ThemePreference($flag: String!) {
  featureFlag(name: $flag) {
    name
    enabled
  }
  currentUser {
    id
    colorModePreference
  }
}
    `;

/**
 * __useThemePreferenceQuery__
 *
 * To run a query within a React component, call `useThemePreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemePreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemePreferenceQuery({
 *   variables: {
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useThemePreferenceQuery(baseOptions: Apollo.QueryHookOptions<ThemePreferenceQuery, ThemePreferenceQueryVariables> & ({ variables: ThemePreferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemePreferenceQuery, ThemePreferenceQueryVariables>(ThemePreferenceDocument, options);
      }
export function useThemePreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemePreferenceQuery, ThemePreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemePreferenceQuery, ThemePreferenceQueryVariables>(ThemePreferenceDocument, options);
        }
// @ts-ignore
export function useThemePreferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ThemePreferenceQuery, ThemePreferenceQueryVariables>): Apollo.UseSuspenseQueryResult<ThemePreferenceQuery, ThemePreferenceQueryVariables>;
export function useThemePreferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemePreferenceQuery, ThemePreferenceQueryVariables>): Apollo.UseSuspenseQueryResult<ThemePreferenceQuery | undefined, ThemePreferenceQueryVariables>;
export function useThemePreferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemePreferenceQuery, ThemePreferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThemePreferenceQuery, ThemePreferenceQueryVariables>(ThemePreferenceDocument, options);
        }
export type ThemePreferenceQueryHookResult = ReturnType<typeof useThemePreferenceQuery>;
export type ThemePreferenceLazyQueryHookResult = ReturnType<typeof useThemePreferenceLazyQuery>;
export type ThemePreferenceSuspenseQueryHookResult = ReturnType<typeof useThemePreferenceSuspenseQuery>;
export type ThemePreferenceQueryResult = Apollo.QueryResult<ThemePreferenceQuery, ThemePreferenceQueryVariables>;
export const UpdateColorModePreferenceDocument = gql`
    mutation UpdateColorModePreference($id: ID!, $colorModePreference: String!) {
  updateUser(id: $id, input: {colorModePreference: $colorModePreference}) {
    result {
      id
      colorModePreference
    }
  }
}
    `;
export type UpdateColorModePreferenceMutationFn = Apollo.MutationFunction<UpdateColorModePreferenceMutation, UpdateColorModePreferenceMutationVariables>;

/**
 * __useUpdateColorModePreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateColorModePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColorModePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColorModePreferenceMutation, { data, loading, error }] = useUpdateColorModePreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      colorModePreference: // value for 'colorModePreference'
 *   },
 * });
 */
export function useUpdateColorModePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColorModePreferenceMutation, UpdateColorModePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColorModePreferenceMutation, UpdateColorModePreferenceMutationVariables>(UpdateColorModePreferenceDocument, options);
      }
export type UpdateColorModePreferenceMutationHookResult = ReturnType<typeof useUpdateColorModePreferenceMutation>;
export type UpdateColorModePreferenceMutationResult = Apollo.MutationResult<UpdateColorModePreferenceMutation>;
export type UpdateColorModePreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateColorModePreferenceMutation, UpdateColorModePreferenceMutationVariables>;